import EmailReplyInnerPage from './EmailReplyInnerPage';

export default EmailReplyInnerPage;
